<template>
    <div class="exam-knowledgepoint">
        <el-form :model="ruleForm" size="mini" label-width="80px">
            <el-form-item label="题库：" prop="fieldId" v-if="fieldList.length > 0">
                <el-radio-group v-model="ruleForm.fieldId" @change="getChaptersByField">
                    <!-- <el-radio-button label="all">全部</el-radio-button> -->
                    <el-radio-button v-for="field in fieldList" :key="field.fieldId" :label="field.fieldId">
                        {{ field.fieldName }}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div>
            <el-button size="mini" icon="el-icon-plus" :disabled="!ruleForm.fieldId" @click="addChapter">
                添加章节
            </el-button>
        </div>
        <div>
            <el-tree show-checkbox default-expand-all :data="chapterTree" node-key="pointId"
                :expand-on-click-node="false" :props="{ label: 'pointName' }">
                <div class="custom-tree-node" slot-scope="{ node, data }">
                    <span>{{ node.label }}</span>
                    <span>
                        <el-button type="text" size="mini" @click="() => append(data)" :disabled="data.state === 1"
                            v-if="data.pid < 1">
                            添加
                        </el-button>
                        <el-button type="text" size="mini" @click="() => edit(data)">
                            编辑
                        </el-button>
                        <el-button type="text" size="mini" @click="() => changeState(data)"
                            :class="`text-${data.state === 1 ? 'primary' : 'warning'}`">
                            {{ data.state === 1 ? "启用" : "禁用" }}
                        </el-button>
                        <el-button type="text" size="mini" @click="() => deleted(data)" :class="'text-danger'"
                            v-if="data.pid < 1">
                            删除
                        </el-button>
                    </span>
                </div>
            </el-tree>
        </div>
        <el-dialog width="30%" :title="`${newChapterChild.pointId ? '编辑' : '添加'}章节`" :visible.sync="chapterVisible">
            <div>
                <el-form ref="chapterForm" :model="newChapterChild" :rules="rules" size="mini" label-width="100px">
                    <el-form-item label="题库ID：" prop="fieldId">
                        <el-input disabled v-model.number="newChapterChild.fieldId"></el-input>
                    </el-form-item>
                    <el-form-item label="章节ID：" prop="pointId">
                        <el-input disabled v-model.number="newChapterChild.pointId"></el-input>
                    </el-form-item>
                    <el-form-item label="父章节ID：" prop="pid">
                        <el-input disabled v-model.number="newChapterChild.pid"></el-input>
                    </el-form-item>
                    <el-form-item label="父章节IDS：" prop="pids">
                        <el-input disabled v-model="newChapterChild.pids"></el-input>
                    </el-form-item>
                    <el-form-item label="章节名称：" prop="pointName">
                        <el-input placeholder="请输入章节名称" v-model="newChapterChild.pointName"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button @click="chapterVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSave">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getAllEtfield } from "@/api/exam/etfield";
import { getEtknowledgepointTree, editKnowledgepoint, delKnowledgepoint } from "@/api/exam/etknowledgepoint";
export default {
    data () {
        return {
            chapterVisible: false,
            ruleForm: {
                fieldId: "" // 题库ID
            },
            fieldList: [], // 题库列表
            chapterTree: [], // 指定题库下的章节tree
            newChapterChild: {}, // 当前编辑的章节
            rules: {
                pointName: [
                    {
                        required: true,
                        message: "请输入章节名称",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    methods: {
        init () {
            this.getAllField();
        },
        // 获取题库列表
        getAllField () {
            getAllEtfield().then(res => {
                if (res.length > 0) {
                    this.ruleForm.fieldId = res[0].fieldId || null;
                    this.fieldList = res;
                    this.getChaptersByField();
                }
            });
        },
        // 获取题库下面的章节树结构
        getChaptersByField () {
            let { fieldId } = this.ruleForm;
            if (fieldId) {
                getEtknowledgepointTree(fieldId).then(res => {
                    this.chapterTree = res;
                });
            }
        },
        handleSave () {
            this.$refs["chapterForm"].validate(valid => {
                if (valid) {
                    this.chapterVisible = false;
                    this.submitChapter();
                }
            });
        },
        addChapter () {
            const { fieldId } = this.ruleForm;
            this.chapterVisible = true;
            this.newChapterChild = {
                fieldId,
                pointName: "",
                pid: 0,
                pids: "0"
            };
        },
        append (data) {
            const { pointId, pids } = data;
            const { fieldId } = this.ruleForm;
            const newChild = {
                fieldId,
                pointName: "",
                pid: pointId,
                pids: `${pids},${pointId}`
            };
            this.chapterVisible = true;
            this.newChapterChild = newChild;
        },
        edit (data) {
            const { fieldId, pointId, pointName, pid, pids } = data;
            this.chapterVisible = true;
            this.newChapterChild = {
                fieldId,
                pointId,
                pointName,
                pid,
                pids
            };
        },
        changeState (data) {
            const { fieldId, pointId, pointName, pid, pids, state } = data;
            this.newChapterChild = {
                fieldId,
                pointId,
                pointName,
                pid,
                pids,
                state: state === 0 ? 1 : 0
            };
            this.submitChapter();
        },
        deleted (data) {
            this.$confirm('此操作将永久删除该章节及该章节以下所有子节点, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const { pointId } = data;
                delKnowledgepoint([pointId]).then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getChaptersByField();
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        submitChapter () {
            editKnowledgepoint(this.newChapterChild).then(() => {
                this.$message.success("操作成功");
                this.getChaptersByField();
            });
        }
    },
    created () {
        this.init();
    }
};
</script>

<style lang="scss">
.exam-knowledgepoint {
    .el-radio-group {
        .el-radio-button {
            .el-radio-button {
                &__inner {
                    border-radius: 0;
                }
                &__orig-radio {
                    &:not(:checked) {
                        & + .el-radio-button__inner {
                            border: 1px solid #dcdfe6;
                        }
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.exam-knowledgepoint {
    .el-radio-group {
        margin: -3px -6px;
        .el-radio-button {
            margin: 3px 6px;
        }
    }
    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }
}
</style>